import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"rectoplus-button",attrs:{"to":_vm.redirect,"width":_vm.width,"disabled":_vm.disabled,"color":_vm.color,"elevation":_vm.elevation,"outlined":_vm.outlined},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }